var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":"Number of Data Points"}},[_c('p',[_vm._v("by site")]),_c('div',{staticClass:".thread-consent-ct1"},[_c('div',{class:_vm.containerClass},[_c('bar-chart',{attrs:{"data":_vm.vis,"options":_vm.options}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }